import { gql, useQuery } from '@apollo/client'

import {
  StorePurchaseOrderConnectionFragmentDoc,
  StorePurchaseOrdersQuery,
  StorePurchaseOrdersQueryVariables,
} from '@/clients/utoniq-core/schema'
import { makeViewModel } from '@/core/architecture'

import { Action, State } from './template'

export const useViewModel = makeViewModel<State, Action>(() => {
  const { data, loading, fetchMore } = useQuery<
    StorePurchaseOrdersQuery,
    StorePurchaseOrdersQueryVariables
  >(QUERY)

  return {
    state: {
      loading,
      hasNextPage: !!data?.userCartTransactionOrders.pageInfo.hasNextPage,
      purchaseHistories: data?.userCartTransactionOrders ?? null,
    },
    actions: {
      async onFetchMore() {
        await fetchMore({
          variables: {
            pageInput: {
              cursor: data?.userCartTransactionOrders.pageInfo.endCursor,
            },
          },
        })
      },
    },
  }
})

const QUERY = gql`
  query StorePurchaseOrders($pageInput: PageInput, $skuId: String) {
    userCartTransactionOrders(pageInput: $pageInput) {
      ...StorePurchaseOrderConnection
    }
  }
  ${StorePurchaseOrderConnectionFragmentDoc}
`
